import { TextField } from "@mui/material";
import { ChangeEventHandler } from "react";

export default function FormPassword(props: {
    label: string,
    name: string,
    value: string,
    required?: boolean,
    disabled?: boolean,
    onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
}) {
    return (
        <TextField
            fullWidth
            type="password"
            label={props.label}
            name={props.name}
            value={props.value || ""}
            onChange={props.onChange}
            required={props.required}
            disabled={props.disabled}
        />
    )
}